import { ApplicationConfig, provideBrowserGlobalErrorListeners, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeuix/themes/aura';
import { definePreset } from '@primeuix/themes';
import { registerLocaleData } from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { appHttpInterceptor } from './core/interceptor/app-http.interceptor';
import { provideAppIcons } from './core/icons/icons.provider';
import { provideServiceWorker } from '@angular/service-worker';

registerLocaleData(localeFr);
const MyGymoPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '{orange.50}',
      100: '{orange.100}',
      200: '{orange.200}',
      300: '{orange.300}',
      400: '{orange.400}',
      500: '{orange.500}',
      600: '{orange.600}',
      700: '{orange.700}',
      800: '{orange.800}',
      900: '{orange.900}',
      950: '{orange.950}'
    }
  }
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([appHttpInterceptor])),
    provideAppIcons(),
    providePrimeNG({
      theme: {
        preset: MyGymoPreset,
        options: {
          darkModeSelector: '.dark',
        }
      },
      translation: {
        startsWith: 'Commence par',
        contains: 'Contient',
        notContains: 'Ne contient pas',
        endsWith: 'Se termine par',
        equals: 'Égal à',
        notEquals: 'Pas égal à',
        noFilter: 'Aucun filtre',
        lt: 'Moins que',
        lte: 'Inférieur ou égal à',
        gt: 'Plus grand que',
        gte: 'Supérieur ou égal à',
        is: 'Est',
        isNot: 'N\'est pas',
        before: 'Avant',
        after: 'Après',
        dateIs: 'La date est',
        dateIsNot: 'La date n\'est pas',
        dateBefore: 'La date est avant',
        dateAfter: 'La date est après',
        clear: 'Effacer',
        apply: 'Appliquer',
        matchAll: 'Correspondre à tous',
        matchAny: 'Correspondre à n\'importe lequel',
        addRule: 'Ajouter une règle',
        removeRule: 'Supprimer une règle',
        accept: 'Accepter',
        reject: 'Rejeter',
        choose: 'Choisir',
        upload: 'Télécharger',
        cancel: 'Annuler',
        dayNames: ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
        dayNamesShort: ['dim', 'lun', 'mar', 'mer', 'jeu', 'ven', 'sam'],
        dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
        monthNames: ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'],
        monthNamesShort: ['janv', 'févr', 'mars', 'avr', 'mai', 'juin', 'juil', 'août', 'sept', 'oct', 'nov', 'déc'],
        today: 'Aujourd\'hui',
        weekHeader: 'Semaine',
        firstDayOfWeek: 1,
        dateFormat: 'dd/mm/yy',
        weak: 'Faible',
        medium: 'Moyen',
        strong: 'Fort',
        passwordPrompt: 'Saisissez un mot de passe',
        emptyFilterMessage: 'Aucun résultat trouvé',
        searchMessage: 'Résultats disponibles',
        selectionMessage: '{0} éléments sélectionnés',
        emptySelectionMessage: 'Aucun élément sélectionné',
        emptySearchMessage: 'Aucun résultat trouvé',
        emptyMessage: 'Aucune option disponible',
        fileChosenMessage: 'Fichier choisi',
        noFileChosenMessage: 'Aucun fichier choisi',
      }
    }), 
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    })
  ]
};
